{
  "actions": {
    "submit": "Nộp"
  },
  "common": {
    "most_imaginable": "Có thể tưởng tượng nhất",
    "not_at_all": "Không có gì"
  },
  "report": {
    "builder": {}
  },
  "survey": {
    "select_before_response": "Chọn câu trả lời trước của bạn.",
    "select_response": "Chọn phản hồi.",
    "select_your_response": "Chọn câu trả lời của bạn.",
    "tell_us_more_one_rating": "Bạn có thể cho chúng tôi biết lý do bạn đưa ra đánh giá này không?",
    "tell_us_more_two_ratings": "Bạn có thể cho chúng tôi biết lý do tại sao bạn lại đưa ra hai đánh giá này không?"
  }
}
